import { isDefined, isNonEmpty } from '@sgme/fp';

import { ErrorRates } from '@/App/tiles/shared/ErrorRates.tsx';
import { useTargetAccumulatorSelector } from '@/App/tiles/TargetAccumulator/TargetAccumulatorContext.tsx';
import { getTargetAccumulatorQuote, getTargetAccumulatorRfsId } from '@/store/targetAccumulator/selectors.ts';

export function StreamingError() {
  const { errorCode, errorMessage, multipassErrorCode, rfsId, predealChecks } = useTargetAccumulatorSelector(
    (targetAccumulator) => {
      const rfsId = getTargetAccumulatorRfsId(targetAccumulator);
      if (targetAccumulator.properties.rfs.status !== 'ERROR') {
        return {
          errorCode: undefined,
          errorMessage: undefined,
          multipassErrorCode: undefined,
          rfsId: rfsId,
          predealChecks: [],
        };
      }

      return {
        errorCode: targetAccumulator.properties.rfs.error.errorCode,
        errorMessage: targetAccumulator.properties.rfs.error.errorMessage,
        multipassErrorCode: targetAccumulator.properties.rfs.error.multipassErrorCode,
        rfsId,
        predealChecks: getTargetAccumulatorQuote(targetAccumulator)?.predealChecks ?? [],
      };
    },
  );

  function computeErrorTranslationKey(errorCode: string, errorMessage: string): string {
    const newErrorCode = errorMessage.substring(0, errorMessage.indexOf('|'));
    if (isNonEmpty(newErrorCode)) {
      return `${newErrorCode}_${errorCode}`;
    }
    return errorCode;
  }

  const errorKey =
    isDefined(errorMessage) && isDefined(errorCode) ? computeErrorTranslationKey(errorCode, errorMessage) : errorCode;

  const multipass = isDefined(errorCode) ? { code: multipassErrorCode, sessionId: rfsId, predealChecks } : undefined;

  return <ErrorRates code={errorKey} message={errorMessage} multipass={multipass} />;
}
